export function insertAtIndex<T>(item: T, index: number, data: T[]): T[] {
  return [...data.slice(0, index), item, ...data.slice(index)];
}
